namespace TabAurous.Common {
    export interface RateResponse extends Serenity.ServiceResponse {
        AttributeId?: number;
        PriceListId?: number;
        ProductTypeId?: number;
        ItemTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneSizeId?: number;
        ShapeId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        QualityId?: number;
        StoneColorId?: number;
        FromWt?: number;
        ToWt?: number;
        PurStdRate?: number;
        SaleStdRate?: number;
        Amount?: number;
        ProductId?: number;
        FromDate?: string;
        ToDate?: string;
        IsCutomerItem?: boolean;
    }
}
